module.exports = __webpack_public_path__ + "static/media/bottom_shape_3.8bce523e.svg";